import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { setAnchorElementsTarget } from '../../../../util';
import {
  ArticleDetailsPage,
  ArticleBody,
  ArticleDate,
  ArticleTitle,
  AuthorName,
  AuthorNameRow,
  ProfilePicContainer,
} from './ZendeskArticleDetails.styles';

const formatDate = (date) => {
  return moment(date).format('ddd, MMMM DD, YYYY [at] h:mma');
};

const ZendeskArticleDetails = ({ zendesk }) => {
  const selectedArticle = zendesk.selectedArticle;
  const createdAt = selectedArticle.created_at;
  const updatedAt = selectedArticle.updated_at;
  const formattedCreatedAt = formatDate(createdAt);
  let formattedUpdatedAt = formatDate(updatedAt);

  if (formattedCreatedAt === formattedUpdatedAt) {
    formattedUpdatedAt = null;
  }

  const users = zendesk.users;
  const author = users[selectedArticle.author_id];
  const profilePic = author && author.photo && author.photo.content_url;

  return (
    <ArticleDetailsPage>
      <div className="row">
        <div className="col-xs-12">
          <ArticleTitle>{selectedArticle.title}</ArticleTitle>
        </div>
      </div>
      <AuthorNameRow className={'row ' + (author ? '' : ' hidden')}>
        <div className="col-xs-12">
          <ProfilePicContainer className={profilePic ? '' : ' hidden'}>
            <img className="profile-pic" alt="" src={profilePic} />
          </ProfilePicContainer>
          <AuthorName>{author && author.name}</AuthorName>
        </div>
      </AuthorNameRow>
      <div className="row">
        <div className="col-xs-12">
          <div className="article-date">Created on {formattedCreatedAt}</div>
        </div>
      </div>
      <div className={'row ' + (formattedUpdatedAt ? '' : ' hidden')}>
        <div className="col-xs-12">
          <ArticleDate>Last updated on {formattedUpdatedAt}</ArticleDate>
        </div>
      </div>
      <ArticleBody dangerouslySetInnerHTML={{ __html: setAnchorElementsTarget(selectedArticle.body) }} />
    </ArticleDetailsPage>
  );
};

ZendeskArticleDetails.propTypes = {
  zendesk: PropTypes.shape({
    selectedArticle: PropTypes.shape({
      title: PropTypes.string,
      body: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default ZendeskArticleDetails;
